export const ACCOUNT_LANGUAGE_LOOKUP = {
  url: "static-data/filter/LOOKUP_FILTER/filters?filter[lookupName]=LKLanguage",
  textKey: "text",
  valueKey: "value",
};
export const ACCOUNT_TIMEZONE_LOOKUP = {
  url: "static-data/filter/LOOKUP_FILTER/filters?filter[lookupName]=LKTimeZone",
  textKey: "text",
  valueKey: "value",
};
export const ACCOUNT_COUNTRY_LOOKUP = {
  url: "static-data/filter/LOOKUP_FILTER/filters?filter[lookupName]=LKCountry",
  textKey: "text",
  valueKey: "value",
};
